import P from "components/P";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import VerticalFlex from "layouts/flex/VerticalFlex";
import Center from "layouts/wrapper/Center";
import { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CartReducer } from "shared/redux/reducers/shopping/CartReducer";
import liquidImg from "resources/img/best/liquid1.png";
import Dummy from "components/Dummy";
import closeIcon from "resources/img/puffu/close.png";
import { BrowserDetectContext } from "providers/BrowserEventProvider";

function MobileCartProductCard(props) {
    const { data } = props;
    const [quantity, setQuantity] = useState(1);
    const dispatch = useDispatch();
    const { isMobile } = useContext(BrowserDetectContext);

    const increaseQuantity = () => {
        const newQuantity = quantity + 1;
        setQuantity(newQuantity);
        // 상품 ID와 새로운 수량을 payload로 전달
        dispatch(CartReducer.actions.updateQuantity({ id: data.id, quantity: newQuantity }));
    };

    const decreaseQuantity = () => {
        if (quantity > 1) {
            // 수량이 1보다 크면 1 감소
            const newQuantity = quantity - 1;
            setQuantity(newQuantity);
            dispatch(CartReducer.actions.updateQuantity({ id: data.id, quantity: newQuantity }));
        } else {
            // 수량이 1인 경우, 해당 상품을 장바구니에서 삭제하는 액션 디스패치
            // dispatch(CartReducer.actions.removeProductFromCart({ id: data.id }));
        }
    };
    const onClose = () => {
        dispatch(CartReducer.actions.removeProductFromCart({ id: data.id }));
    }

    useEffect(() => {
        setQuantity(data.quantity);
    }, [data])

    return (
        <div
            style={{
                display: "flex",
                // flex: "1 1 23%",
                justifyContent: "center",
                alignItems: "center",
                padding: "20px 0",
            }}
        >
            <div style={{
                width: "93%",
                padding: "10px",
                backgroundColor: "white",
                position: "relative"
            }}>
                <VerticalFlex gap={10}>
                    <FlexChild>

                        <div style={{
                            width: "max-content",
                            position: "absolute",
                            right: "10px",

                            cursor: "pointer",
                        }} onClick={onClose}>
                            <img src={closeIcon} width={"10px"} style={{ filter: "invert(100%)" }} />
                        </div>
                    </FlexChild>
                    <FlexChild>
                        <HorizontalFlex>
                            <FlexChild width={"40%"}>
                                <div
                                    style={{
                                        display: "flex"
                                    }}
                                >
                                    <img src={data.productImg} width={"100%"} />
                                </div>
                            </FlexChild>
                            <FlexChild>
                                <Center width={"100%"} textAlign={"left"}>
                                    <P size={16}>
                                        {data.productName}
                                    </P>
                                    <P size={20} font={"gmarketSansBold"} color={"var(--main-color)"}>
                                        {data.price && data.price.toLocaleString()}원
                                    </P>
                                </Center>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild width={"90%"} height={"1.5px"} backgroundColor={"black"} />
                    <FlexChild>
                        <HorizontalFlex>
                            <FlexChild justifyContent={"center"}>
                                <div
                                    style={{
                                        width: "25px",
                                        height: "25px",

                                        backgroundColor: quantity <= 1 ? "#eee" : "#EC4715",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    onClick={decreaseQuantity}
                                >
                                    <P size={20} color={"white"}>
                                        -
                                    </P>
                                </div>
                            </FlexChild>
                            <FlexChild justifyContent={"center"}>
                                <P weight={"bold"} size={25}>
                                    {quantity && quantity}
                                </P>
                            </FlexChild>



                            <FlexChild justifyContent={"center"}>
                                <div
                                    style={{
                                        width: "25px",
                                        height: "25px",

                                        backgroundColor: "#EC4715",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                    }}
                                    onClick={increaseQuantity}
                                >
                                    <P size={20} color={"white"}>
                                        +
                                    </P>
                                </div>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                </VerticalFlex>
            </div>
        </div >

    );
}

export default MobileCartProductCard;